import { Helmet } from "react-helmet-async";

export function PageSEO({ title, description, path }) {
  const baseUrl = "https://your-it-solutions.co.uk";
  const fullTitle = title + " | Your-IT-Solutions";
  const url = baseUrl + (path || "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
